import React,  { useContext } from "react";
import { Box, Dialog, DialogContent, DialogTitle } from "@material-ui/core";
import Parser from 'html-react-parser';
// import theme from "../../../theme";
import { contentActions } from "../../store/content-reducer";
import { storeContext } from "../provider/Provider";

const ClientNotesDialogContent = () => {
   const { state, dispatch } = useContext(storeContext);

   const handleClose = () => {
      
      dispatch({
         type: contentActions.SET_SELECTED_CLIENT_NOTE,
         payload: { 
            selectedClientNote: '',
         }
      })
      dispatch({
         type: contentActions.SET_CLIENT_NOTES_OPEN,
         payload: { 
            clientNotesOpen: false,
         }
      })
   }

   return (
      <Dialog
         open={state.content.clientNotesOpen}
         onClose={handleClose}
      >
         <DialogTitle style={{background: "#e0e0e0"}}>
            Client Note
         </DialogTitle>
         <DialogContent style={{minWidth: "200px", maxWidth: "600px"}}>
            <Box textAlign='left' my={3} mx={2}>
               {Parser(state.content.selectedClientNote)}
            </Box>
         </DialogContent>
      </Dialog>)
}

export default ClientNotesDialogContent
